<div mat-dialog-title class="dialog-header-container">

    <div class="header-content">
        <h2>{{getSummaryTitle()}}</h2>
        <span class="mat-font-body-md" *ngIf="!loading">{{getSummaryDescription()}}</span>
    </div>
    <button matIconButton class="close-button" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <div class="loading-container" *ngIf="loading">
        <mat-spinner [diameter]="100" class="preview-loading"></mat-spinner>
    </div>
    <div class="request-summary" [ngClass]="{'request-summary' : !formSubmitted, 'request-summary-disabled' : formSubmitted}" *ngIf="!loading">
        <div class="summary-title">
            <span class="text-title-medium">Request summary</span>
        </div>
        <div class="summary-content">
            <br>
            <div [ngClass]="{'summary-field-name' : !formSubmitted, 'summary-field' : formSubmitted}">
                <span class="left-content"><b>File name:</b></span> <span>{{data.layer.name}}</span>
            </div>
            <div class="summary-field">
                <span class="left-content"><b>Number of properties*:</b></span> <span>{{aoiSelected ? aoiSelected.features.length : data.layer.source.features.features.length}} properties</span>
            </div>
            <div class="summary-field">
                <span class="left-content"><b>Event name:</b></span>
                <span>
                    <mat-form-field *ngIf="!formSubmitted" class="form-slim">
                        <mat-select placeholder="Select event" [(ngModel)]="aoiSelected" [disabled]="formSubmitted">

                            <mat-option *ngFor="let aoi of availableAOIs" [value]="aoi" (click)="calculateFeatures(aoi)">{{aoi.prettyName || aoi.name}}</mat-option>

                        </mat-select>
                    </mat-form-field>
                    <span *ngIf="formSubmitted">{{aoiSelected.prettyName ? aoiSelected.prettyName : aoiSelected.name}}</span>
                </span>
            </div>
            <div class="summary-field">
                <span class="left-content"><b>Event date:</b></span> <span>{{aoiSelected ? aoiSelected.date.split(" ")[0].replaceAll("-","/") : ""}}</span>
            </div>
        </div>
    </div>
    <span *ngIf="!formSubmitted">* Recommend processing no more than 1000 properties in a single batch.</span>

</mat-dialog-content>

<mat-dialog-actions>
    @if (!loading && !formSubmitted) {
        <button (click)="closeDialog()" matButton="elevated" >
            {{"Back"}}
        </button>
        <button (click)="submit()" matButton="elevated"  [disabled]="!aoiSelected || !aoiSelected.features.length">{{"Review"}}</button>
    } @else if (!loading && formSubmitted) {
        <button (click)="cancel()" matButton="elevated" >
        {{"Cancel"}}
        </button>
        <button (click)="getDamageAssessment(aoiSelected)" matButton="elevated"  [disabled]="!aoiSelected">{{"Start Processing"}}</button>
    }

</mat-dialog-actions>
